define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function HashCalcError(stack, source) {
        UploadFail.apply(this, arguments);
    }

    HashCalcError.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: HashCalcError,
        className: 'HashCalcError',
        radarName: 'filehash_fail',
        message: 'Не удалось посчитать хэш файла.',
    });

    module.exports = HashCalcError;
});
